import en from './en'

// NOTE: DO NOT UPDATE THIS RESERVED TRANSLATION KEYS AND THEIR VALUES
const reservedTranslationsWithUniqueKeyNames = {
  '404': '404',
  leadingSpaceNotAllowed: 'L\'espace au début n\'est pas autorisé.',
  trailingSpaceNotAllowed: 'L\'espace à la fin n\'est pas autorisé.',
  mustbeAtleastCharacters: '{{label}} doit contenir au moins {{minNumber}} caractères',
  cannotExceedCharacters: '{{label}} ne peut pas dépasser {{maxNumber}} caractères',
  numberMustbeAtleast: '{{label}} doit être au moins {{minNumber}}',
  numberCannotExceed: '{{label}} ne peut pas dépasser {{maxNumber}}',
  isRequired: '{{label}} est obligatoire',
  emptySpaceNotContain: 'Ce champ ne peut pas contenir d\'espace',
  register: 'S\'inscrire',
  login: 'Connexion',
  comingSoon: 'Bientôt disponible',
  submit: 'Envoyer',
  email: 'E-mail',
  termsConditions: 'Conditions générales',
  password: 'Mot de passe',
  eighteenPlus: 'J\'ai plus de 18 ans et j\'accepte les conditions d\'utilisation',
  signUp: 'Inscription',
  createNewAccount: 'Créer un nouveau compte',
  fullName: 'Nom complet',
  referralCode: 'Code de parrainage',
  confirmPassword: 'Confirmer le mot de passe',
  facebook: ' Facebook',
  google: 'Google',
  haveAnAccount: 'Vous avez un compte ? ',
  pageNotFound: 'Nous ne trouvons pas la page que vous cherchez !',
  error: 'Erreur',
  somethingWentWrong: 'Une erreur s\'est produite !',
  personalDetails: 'Informations personnelles',
  firstName: 'Prénom',
  lastName: 'Nom',
  dateOfBirth: 'Date de naissance',
  phoneNumber: 'Numéro de téléphone',
  change: 'Modifier',
  saveChanges: 'Enregistrer les modifications',
  currentPassword: 'Mot de passe actuel',
  newPassword: 'Nouveau mot de passe',
  myProfile: 'Mon profil',
  transactions: 'Transactions',
  deposit: 'Dépôt',
  withdraw: 'Retrait',
  referral: 'Parrainage',
  changePassword: 'Changer le mot de passe',
  logout: 'Déconnexion',
  currency: 'Devise.',
  view: 'Voir',
  ok: 'OK',
  cancel: 'Annuler',
  userName: 'Nom d\'utilisateur',
  passwordRegexMatch: 'Le mot de passe doit contenir une majuscule, un chiffre et un caractère spécial',
  invalidEmailFormat: 'Format d\'e-mail invalide',
  noRecordsFound: 'Aucun enregistrement trouvé',
  backToLobby: 'Retour au lobby',
  placeBet: 'Placer un pari',
  rOICalculator: 'Calculateur de ROI',
  activeBets: 'PARIS ACTIFS',
  closedBets: 'PARIS FERMÉS',
  publicBets: 'PARIS PUBLICS',
  leaderboard: 'CLASSEMENT',
  howToplay: 'Comment jouer',
  bustPriceLabel: 'Prix de bust',
  multiplierLabel: 'MULTIPLICATEUR',
  pnLFee: 'Frais de PnL',
  flatFee: 'Frais fixes',
  takeProfitLabel: 'PRENDRE LE PROFIT AU PRIX',
  closeBetLabel: 'FERMER LE PARI AU PRIX',
  priceUpLabel: 'LE PRIX VA-T-IL MONTER OU BAISSER ?',
  payoutMul: 'MULTIPLICATEUR DE GAIN',
  allCurrencies: 'Toutes les devises',
  monthLabel: 'Mois',
  day: 'Jour',
  week: 'Semaine',
  betLabel: 'Libellé du pari',
  entryPrice: 'Prix d\'entrée',
  closeBetErr: 'Saisissez un montant valide pour fermer le pari',
  mulValErr: 'Valeur du multiplicateur entre 100 et 1000',
  profitErr: 'Saisissez un montant de prise de profit valide'
}

// NOTE: PLEASE ADD YOUR API SUCCESS MESSAGE TRANSLATIONS HERE ONLY
const apiSuccessMessagesTranslations = {
  loginSuccessfully: 'Connexion réussie.',
  logoutSuccessfully: 'Déconnexion réussie.',
  passwordUpdateSuccessfully: 'Mot de passe mis à jour avec succès.',
  updatePlayerStatusSuccessfully: 'Statut du joueur mis à jour avec succès.',
  resetPasswordSuccessfully: 'Mot de passe réinitialisé avec succès.',
  signupSuccessfully: 'Inscription réussie.',
  betPlacedSuccessfully: 'Pari placé avec succès.',
  betCancelledSuccessfully: 'Pari annulé avec succès.'
}

// NOTE: PLEASE ADD YOUR API ERROR MESSAGE TRANSLATIONS HERE ONLY
const apiErrorMessagesTranslations = {
  UnAuthorized: 'Votre session a expiré',
  LoginFailedError: 'Échec de la connexion',
  InvalidCredentialsError: 'Identifiants invalides',
  InvalidTokenError: ' Le jeton n\'est pas valide',
  InvalidSessionError: ' Session expirée',
  CreateUserError: 'L\'utilisateur ne peut pas être créé',
  DataMismatchError: 'Les données ne correspondent pas',
  UserNotFoundError: 'Utilisateur introuvable',
  DuplicateEmailError: 'L\'e-mail existe déjà',
  RequestInputValidationError: 'Veuillez vérifier les données de la requête',
  ResponseInputValidationError: 'La validation de la réponse a échoué, veuillez consulter le schéma JSON de la réponse',
  SocketRequestInputValidationError: 'Veuillez vérifier les données de la requête pour la communication socket',
  SocketResponseValidationError: 'La validation de la réponse de la communication socket a échoué, veuillez consulter le schéma JSON de la réponse',
  InternalServerError: 'Erreur interne du serveur',
  InvalidSocketArgumentError: 'Veuillez fournir les arguments appropriés : eventName, [payloadObject] et [callback]',
  InvalidCredentials: 'Les identifiants ne correspondent pas',
  InvalidToken: 'Le jeton d\'accès n\'a pas été transmis ou a expiré',
  InvalidSession: 'La session utilisateur n\'est pas valide, veuillez vous reconnecter',
  InvalidAccess: 'Autorisation refusée',
  NonOperationalError: 'Une erreur s\'est produite sur le serveur',
  UserNotExists: 'L\'utilisateur n\'existe pas',
  InvalidAction: 'Action invalide',
  SessionAlreadyStarted: 'Session déjà démarrée',
  SessionNotStarted: 'Session non démarrée',
  EmailNotVerified: 'E-mail non vérifié',
  InvalidGameTypeError: 'Aucun paramètre trouvé pour le type de jeu fourni',
  InvalidGameRoundError: 'Aucun jeu trouvé pour les détails fournis',
  NoRoundRunningError: 'Aucune manche n\'est en cours pour le moment',
  NoPlacedBetFoundError: 'Aucun pari placé trouvé',
  NoWalletFoundError: 'Portefeuille introuvable avec les données spécifiées',
  NotEnoughBalanceError: 'Le solde n\'est pas suffisant pour effectuer l\'opération',
  AutoRateIsInvalidError: 'Le taux auto n\'est pas dans la limite valide',
  BetAmountIsNotInLimitError: 'Le montant du pari n\'est pas dans les limites valides',
  EmailNotFound: 'E-mail introuvable',
  UserNotAbove18YearsError: 'L\'utilisateur n\'a pas plus de 18 ans',
  InvalidBlockchainAddress: 'Adresse blockchain invalide',
  AddressMismatch: 'L\'adresse fournie et l\'adresse récupérée ne correspondent pas',
  NonceLifetimeExpired: 'Durée de vie du nonce expirée',
  SomethingWentWrong: 'Une erreur s\'est produite',
  AccountNotActive: 'Le compte n\'est pas actif',
  LoginTokenRequire: 'OTP (mot de passe à usage unique) requis',
  UserAlreadyExists: 'L\'utilisateur existe déjà',
  InvalidVerificationToken: 'Jeton de vérification invalide',
  UserNotActive: 'L\'utilisateur est bloqué, veuillez contacter l\'administrateur',
  FileUploadFailed: 'Échec du téléversement de l\'image',
  EmailAlreadyVerified: 'L\'e-mail est déjà vérifié',
  InvalidReferralCode: 'Code de parrainage invalide',
  InvalidAffiliateCode: 'Code d\'affiliation invalide',
  RecordNotFound: 'Enregistrement introuvable',
  WithdrawalRequestAlreadyPending: 'Une demande de retrait est déjà en attente',
  WalletDoesNotBelongToUser: 'Ce portefeuille n\'appartient pas à cet utilisateur',
  BetAlreadyInProgress: 'Le pari est déjà en cours',
  ServerSeedNotFoundErrorType: 'Graine serveur introuvable, veuillez vous reconnecter',
  InvalidTileErrorType: 'La case doit être comprise entre 1 et 25',
  FavoriteGameExistsErrorType: 'Le jeu favori existe déjà',
  FavoriteGameNotFoundErrorType: 'Jeu favori introuvable',
  TransactionAlreadyPendingErrorType: 'La transaction est déjà en attente',
  UserHasNoActiveBonusErrorType: 'L\'utilisateur n\'a aucun bonus actif',
  BonusExpiredErrorType: 'Le bonus a expiré',
  UserHasAlreadyActivatedBonusWageringErrorType: 'L\'utilisateur a déjà activé la mise du bonus',
  InvalidRoundHashErrorType: 'Hash de manche incorrect',
  InvalidSignatureErrorType: 'Signature incorrecte',
  UserHasNoBonusAmountToClaimErrorType: 'L\'utilisateur n\'a aucun montant de bonus à réclamer',
  BonusNotExistsErrorType: 'Bonus introuvable'
}

// NOTE: PLEASE ADD YOUR OTHER KEY TRANSLATIONS HERE ONLY
const otherTranslationKeys = {
  betAmount: 'Montant du pari',
  betHistory: 'Historique des paris',
  provablyFair: 'Provably Fair',
  minimumBet: 'Mise minimale',
  maximumBet: 'Mise maximale',
  selectYourBetAmount: 'Sélectionnez le montant de votre pari',
  buyInAmount: 'Montant du buy-in',
  selectYourBuyInAmountFromGivenRange: 'Sélectionnez votre montant de buy-in dans la plage indiquée',
  profitOnWin: 'Profit en cas de gain',
  noOfBets: 'Nombre de paris',
  auto: 'Auto',
  half: '½',
  double: '2X',
  start: 'Démarrer',
  cancel: 'Annuler',
  prediction: 'Prédiction',
  luckyNumber: 'Numéro porte-bonheur',
  multiplier: 'Multiplicateur',
  chanceToWin: 'Chance de gagner',
  betBtn: 'Placer un pari',
  bets: 'Paris',
  depositBtn: 'Dépôt',
  rollOver: 'Au-dessus',
  rollUnder: 'En dessous',
  invalidBetAmount: 'Montant de pari invalide',
  maxBetAmountLimit: 'Limite du montant max. de pari {{value}} dépassée',
  minBetAmountLimit: 'La mise minimale est {{value}}.',
  noBalance: 'Le montant du pari est supérieur au solde du portefeuille',
  noAutoCashout: 'Le taux auto est requis.',
  autoRateLimitWarning: 'Le taux auto doit être supérieur à {{value}}'
}

// NOTE: PLEASE ADD YOUR PREDICTION MARKET TRANSLATIONS HERE ONLY
const predictionMarketTranslations = {
  error: 'Erreur',
  somethingWentWrongPleaseTryAgain: 'Une erreur s\'est produite. Veuillez réessayer.',
  market: 'Marché',
  limit: 'Limite',
  buy: 'Acheter',
  sell: 'Vendre',
  yes: 'Oui',
  no: 'Non',
  up: 'Hausse',
  down: 'Baisse',
  yesCents: 'Oui {{cents}}¢',
  noCents: 'Non {{cents}}¢',
  split: 'Split',
  merge: 'Fusion',
  amount: 'Montant',
  shares: 'Parts',
  cancel: 'Annuler',
  submit: 'Envoyer',
  refresh: 'Actualiser',
  loading: 'Chargement',
  loadMore: 'Charger plus',
  gotIt: 'Compris',
  next: 'Suivant',
  previous: 'Précédent',
  trade: 'Trader',
  portfolio: 'Portefeuille',
  rules: 'Règles',
  volume: 'Volume',
  category: 'Catégorie',
  notAvailable: 'N/A',
  open: 'Ouvert',
  closed: 'Fermé',
  removed: 'Supprimé',
  resolved: 'Résolu',
  cancelled: 'Annulé',
  settled: 'Réglé',
  ask: 'Ask',
  bid: 'Bid',
  asks: 'Asks',
  bids: 'Bids',
  total: 'Total',
  outcome: 'Résultat',
  options: 'Options',
  history: 'Historique',
  positions: 'Positions',
  orders: 'Ordres',
  activity: 'Activité',
  comments: 'Commentaires',
  delete: 'Supprimer',
  reply: 'Répondre',
  postComment: 'Publier un commentaire',
  likeCount: 'J\'aime ({{count}})',
  limitPrice: 'Prix limite',
  postOnly: 'Post-only',
  youPay: 'Vous payez',
  shareCost: 'Coût des parts',
  toWin: 'À gagner',
  youWillReceive: 'Vous recevrez',
  averagePrice: 'Prix moyen',
  payable: 'À payer',
  processingFee: 'Frais de traitement',
  processingFees: 'Frais de traitement',
  estProcessingFee: 'Frais de traitement est.',
  estProcessingFeeIncluded: 'Frais de traitement est. (inclus)',
  processingFeeRefundable: 'Frais de traitement (remboursables)',
  showMore: 'afficher plus...',
  feePerShareIfItFillsNow: 'Frais par part s\'il est exécuté maintenant',
  marketSettled: 'Marché réglé',
  resultDeclared: 'Résultat déclaré',
  tradingClosedForThisOption: 'La négociation est fermée pour cette option.',
  waitingForNextMarket: 'Aucun marché en direct pour le moment. Les échanges s’ouvrent au début de la prochaine fenêtre.',
  cryptoLiveNavLabel: 'Live Crypto',
  goBack: 'Retour',
  yourPosition: 'Votre position',
  availableToTrade: 'Disponible pour trader',
  locked: 'Bloqué',
  profitLoss: 'P/L',
  yesShares: 'Parts Oui',
  noShares: 'Parts Non',
  avgYesPrice: 'Prix moyen Oui',
  avgNoPrice: 'Prix moyen Non',
  outcomeShares: 'Parts {{outcome}}',
  avgOutcomePrice: 'Prix moyen de {{outcome}}',
  payoutProfitLoss: 'P/L du paiement',
  outcomeWon: '{{outcome}} a gagné',
  buyOutcome: 'Acheter {{outcome}}',
  sellOutcome: 'Vendre {{outcome}}',
  decreaseAmount: 'Diminuer le montant',
  increaseAmount: 'Augmenter le montant',
  decreaseShares: 'Diminuer les parts',
  increaseShares: 'Augmenter les parts',
  decreaseLimitPrice: 'Diminuer le prix limite',
  increaseLimitPrice: 'Augmenter le prix limite',
  nobodySellingRightNow: 'Personne ne vend pour le moment. Essayez un ordre limite pour qu\'il puisse attendre.',
  nobodyBuyingRightNow: 'Personne n\'achète pour le moment. Essayez un ordre limite pour qu\'il puisse attendre.',
  tooMuchMaxBuy: 'Trop élevé. Le maximum que vous pouvez acheter maintenant est {{amount}}$.',
  tooManySharesMaxSell: 'Trop de parts. Le maximum que vous pouvez vendre maintenant est {{amount}}.',
  restAsMakerOnly: 'Reste uniquement en tant que maker ; rejeté s\'il prendrait de la liquidité',
  mergeMatchedSharesIntoCollateral: 'Fusionner les parts Oui et Non correspondantes en garantie.',
  sharesPerSide: 'Parts (par côté)',
  splitCollateralIntoShares: 'Diviser la garantie en parts Oui et Non pour ce marché.',
  closeTradePanel: 'Fermer le panneau de trading',
  openTradePanel: 'Ouvrir le panneau de trading',
  orderSummary: 'Récapitulatif de l\'ordre',
  youSell: 'Vous vendez',
  youMerge: 'Vous fusionnez',
  estProceedsAtMarket: 'Produit est. au marché',
  splitCollateral: 'Diviser la garantie',
  mergeShares: 'Fusionner les parts',
  splitHasNoProcessingFee: 'Le split n\'a pas de frais de traitement.',
  mergeHasNoProcessingFee: 'La fusion n\'a pas de frais de traitement.',
  includedInWhatYouPay: 'Inclus dans ce que vous payez. S\'applique lorsque votre ordre correspond aux offres disponibles.',
  deductedFromWhatYouReceive: 'Déduit de ce que vous recevez lorsque votre ordre correspond aux bids disponibles.',
  heldWithYourOrder: 'Retenu avec votre ordre. Remboursé s\'il attend dans le carnet. Conservé seulement s\'il est exécuté immédiatement.',
  onlyIfOrderFillsRightAway: 'Uniquement si votre ordre est exécuté immédiatement — déduit du produit. Aucun frais s\'il attend dans le carnet.',
  makerFeeRebateExplanation: 'Si quelqu\'un d\'autre prend votre ordre en attente, vous pouvez gagner {{rebatePercent}}% de ses frais.',
  postOnlyOrderExplanation: 'Post-only : cet ordre attend uniquement. S\'il devait s\'exécuter immédiatement, il est annulé et vous récupérez votre argent.',
  notEnoughMoneyInWallet: 'Pas assez d\'argent dans votre portefeuille.',
  notEnoughYesAndNoSharesToMerge: 'Pas assez de parts Oui et Non à fusionner.',
  notEnoughSharesToSell: 'Vous n\'avez pas autant de parts à vendre.',
  maxOrderSizeIs: 'La taille maximale de l\'ordre est {{amount}}.',
  orderCrossesOwnSellOrder: 'L\'ordre croiserait votre propre ordre de vente sur ce résultat. Annulez ou baissez d\'abord cette vente.',
  orderCrossesOwnOppositeBuy: 'L\'ordre croiserait votre propre achat du côté opposé (Oui+Non >= 100¢). Annulez ou ajustez d\'abord cet ordre.',
  orderCrossesOwnBuyOrder: 'L\'ordre croiserait votre propre ordre d\'achat sur ce résultat. Annulez ou augmentez d\'abord cet achat.',
  placedBuyLimitOrder: 'Ordre limite d\'achat de {{shares}} parts au prix {{price}} placé',
  placedSellLimitOrder: 'Ordre limite de vente de {{shares}} parts au prix {{price}} placé',
  placedBuyMarketOrder: 'Ordre au marché d\'achat du montant {{amount}} placé',
  placedSellMarketOrder: 'Ordre au marché de vente de {{shares}} parts placé',
  mergedYesAndNoShares: '{{quantity}} parts oui et non fusionnées en montant {{amount}}',
  splitAmountIntoYesAndNoShares: 'Montant {{amount}} divisé en {{yesShares}} parts oui et {{noShares}} parts non',
  closedBuyLimitOrder: 'Ordre limite d\'achat de {{remainingShares}} parts au prix {{price}} clôturé, total {{shares}}',
  closedSellLimitOrder: 'Ordre limite de vente de {{remainingShares}} parts au prix {{price}} clôturé, total {{shares}}',
  closedBuyMarketOrder: 'Ordre au marché d\'achat du montant {{remainingAmount}} clôturé, total {{amount}}',
  closedSellMarketOrder: 'Ordre au marché de vente de {{remainingShares}} parts clôturé, total {{shares}}',
  boughtSharesFromSeller: '{{quantity}} parts achetées au prix {{price}} auprès de {{sellerName}}',
  soldSharesToBuyer: '{{quantity}} parts vendues au prix {{price}} à {{buyerName}}',
  marketResolvedWithOutcome: 'Marché résolu avec le résultat {{outcome}}. Paiement : ${{payout}} ({{winningShares}} parts gagnantes).',
  buyerReceivedSharesSystemMinted: '{{buyerName}} a reçu {{quantity}} parts à {{price}} (émises par le système)',
  buyerBoughtSharesFromSeller: '{{buyerName}} a acheté {{quantity}} parts à {{price}} auprès de {{sellerName}}',
  sellerSoldSharesToSystem: '{{sellerName}} a vendu {{quantity}} parts à {{price}} à SYSTEM',
  sellerSoldSharesToBuyer: '{{sellerName}} a vendu {{quantity}} parts à {{price}} à {{buyerName}}',
  notifications: 'Notifications',
  unreadNotifications: '{{count}} notifications non lues',
  recentCount: '{{count}} récentes',
  loadingNotifications: 'Chargement des notifications...',
  noNotificationsYet: 'Aucune notification pour le moment. Vous serez averti lorsque des ordres sont appariés, terminés ou que des marchés sont résolus.',
  activityUpdate: 'Mise à jour d\'activité',
  marketResolved: 'Marché résolu',
  marketQuestionResolved: 'Le marché « {{questionTitle}} » a été résolu.',
  walletUpdated: 'Portefeuille mis à jour',
  justNow: 'À l\'instant',
  pickAMarket: 'Choisir un marché',
  pickAMarketDescription: 'Ouvrez un marché et choisissez Oui ou Non selon votre prédiction. Utilisez ensuite le panneau d\'ordre pour obtenir des parts.',
  preferLimitOrders: 'Privilégier les ordres limites',
  preferLimitOrdersDescription: 'Commencez ici. Définissez le prix exact (¢) et le nombre de parts. Votre ordre reste dans le carnet jusqu\'à ce que quelqu\'un le corresponde — vous contrôlez ainsi le prix.',
  noFillUseSplit: 'Pas d\'exécution ? Utilisez Split',
  noFillUseSplitDescription: 'S\'il n\'y a pas assez de liquidité pour exécuter un ordre limite, divisez votre garantie en parts Oui et Non égales. Vous pouvez ensuite vendre le côté que vous ne voulez pas.',
  needSpeedMarketOrders: 'Besoin de rapidité ? Ordres au marché',
  needSpeedMarketOrdersDescription: 'Les ordres au marché s\'exécutent instantanément contre le carnet actuel. Utilisez-les lorsque vous voulez des parts maintenant et acceptez de payer le prix du marché.',
  holdOrCashOut: 'Conserver ou encaisser',
  holdOrCashOutDescription: 'Vendez à tout moment avant la résolution, ou conservez jusqu\'au règlement. Les parts gagnantes paient 1 $ chacune ; les parts perdantes sont réglées à 0 $.',
  restsOnTheBookUntilMatched: 'Reste dans le carnet jusqu\'à correspondance',
  convertCashIntoYesAndNoShares: 'Convertir du cash en parts Oui + Non',
  estShares: 'Parts est.',
  fillsInstantlyAtBookPrices: 'S\'exécute instantanément aux prix du carnet',
  resolvedYes: 'Résolu · Oui',
  payoutCredited: 'Paiement crédité',
  closeHowItWorks: 'Fermer le fonctionnement',
  tryItOut: 'Essayer ?',
  willThereBeAUsRecessionThisYear: 'Y aura-t-il une récession aux États-Unis cette année ?',
  exitTutorialAndReturnToMarkets: 'Quitter le tutoriel et revenir aux marchés',
  exitDemo: 'Quitter la démo',
  howItWorks: 'Comment ça marche',
  demoGuide: 'Guide',
  demoGuideReopen: 'Rouvrir le guide de démo',
  demoGuideSkip: 'Passer le guide',
  demoGuideFinish: 'Terminer',
  demoGuideStepOf: 'Étape {{current}} sur {{total}}',
  demoGuideBack: 'Retour',
  demoGuideWelcomeTitle: 'Bienvenue sur le terrain de jeu',
  demoGuideWelcomeBody: 'Ceci est un marché démo sûr avec de l\'argent fictif. Je pointerai chaque élément de l\'interface et expliquerai son rôle — essayez l\'action si vous voulez, ou appuyez sur Suivant à tout moment.',
  demoGuideWelcomeHint: 'Vous commencez avec 1000 $ de solde démo. Rien ici n\'est réel.',
  demoGuideLimitTitle: 'Privilégier les ordres limites',
  demoGuideLimitBody: 'Un ordre limite vous permet de fixer le prix exact (¢) et le nombre de parts. Il reste dans le carnet jusqu\'à correspondance — vous contrôlez le prix au lieu de prendre celui du marché.',
  demoGuideLimitHint: 'J\'ai ouvert Limite et suggéré Acheter Oui à 45¢ × 10. Envoyez si vous voulez essayer, ou Suivant pour continuer.',
  demoGuideOrderbookTitle: 'Votre ordre dans le carnet',
  demoGuideOrderbookBody: 'Le carnet d\'ordres affiche les bids et asks au repos. Lorsque vous placez un ordre limite, il apparaît ici (souvent marqué Vous) jusqu\'à exécution ou annulation.',
  demoGuideOrderbookHint: 'Si vous n\'avez pas encore d\'ordre au repos, je place un petit bid démo pour que vous voyiez à quoi il ressemble.',
  demoGuidePostOnlyTitle: 'Post-only (maker uniquement)',
  demoGuidePostOnlyBody: 'Post-only signifie que votre achat limite ne reste qu\'en tant que maker. Si le prix s\'exécuterait immédiatement contre un ask, l\'ordre est rejeté et votre argent revient — utile si vous ne voulez jamais prendre de liquidité.',
  demoGuidePostOnlyHint: 'Post-only est coché avec un bid à 45¢ qui ne croise pas. Essayez d\'envoyer, ou Suivant pour continuer.',
  demoGuideCancelTitle: 'Annuler un ordre au repos',
  demoGuideCancelBody: 'Vous avez changé d\'avis ? Les ordres ouverts se trouvent sous Ma position. L\'annulation libère l\'argent réservé sur les achats (ou les parts bloquées sur les ventes) pour que vous puissiez les réutiliser.',
  demoGuideCancelHint: 'Utilisez Annuler sur une ligne si vous voulez vous exercer — je garde un bid au repos disponible pour vous.',
  demoGuideMarketTitle: 'Besoin de rapidité ? Ordres au marché',
  demoGuideMarketBody: 'Les ordres au marché s\'exécutent instantanément contre le carnet actuel. Utilisez-les lorsque vous voulez des parts maintenant et acceptez de payer les prix ask en direct au lieu d\'attendre votre limite.',
  demoGuideMarketHint: 'J\'ai défini un achat de 5 $ au marché. Envoyez pour voir une exécution instantanée, ou Suivant pour continuer.',
  demoGuideMintTitle: 'Pas d\'asks ? Le mint fonctionne quand même',
  demoGuideMintBody: 'Si personne ne vend, vous pouvez quand même obtenir des parts. Le moteur peut émettre Oui+Non à partir de la garantie en appariant votre achat à un bid du côté opposé — des asks vides ne veulent donc pas toujours dire « bloqué ».',
  demoGuideMintHint: 'J\'ai retiré les asks de cette option. Un achat au marché de 5 $ est prêt — regardez les parts apparaître même avec un côté ask vide.',
  demoGuideSplitTitle: 'Pas d\'exécution ? Utilisez Split',
  demoGuideSplitBody: 'Split transforme instantanément la garantie en parts Oui et Non égales — sans contrepartie. Pratique lorsque le carnet est mince et que vous voulez un inventaire pour vendre plus tard le côté indésirable.',
  demoGuideSplitHint: 'J\'ai suggéré de splitter 10 $. Essayez pour voir Oui et Non augmenter, ou Suivant pour continuer.',
  demoGuideMergeTitle: 'Fusionner pour revenir au cash',
  demoGuideMergeBody: 'La fusion est l\'inverse du split : brûler des parts Oui et Non égales pour récupérer la garantie. Utile lorsque vous détenez les deux côtés et voulez revenir au cash.',
  demoGuideMergeHint: 'J\'ai suggéré de fusionner 5 par côté. Il vous faut des Oui et Non disponibles correspondants — faites un split d\'abord si besoin.',
  demoGuideResolveTitle: 'Fermer et régler',
  demoGuideResolveBody: 'Lorsque le trading se termine, le marché ferme puis se règle. Les parts gagnantes paient 1 $ chacune ; les parts perdantes sont réglées à 0 $. En démo, Gérer le marché permet de simuler fermer → choisir un gagnant → régler.',
  demoGuideResolveHint: 'Ouvrez le panneau s\'il n\'est pas ouvert. Fermez d\'abord, puis choisissez Oui/Non et Régler pour l\'option sélectionnée.',
  demoGuideDoneTitle: 'Vous avez les bases',
  demoGuideDoneBody: 'Limite pour contrôler le prix, post-only pour rester maker, annuler pour libérer les fonds réservés, marché pour la vitesse, mint lorsque les asks sont vides, split/fusion pour l\'inventaire et gérer le marché pour la résolution.',
  demoGuideDoneHint: 'Rejouez à tout moment depuis le bouton Guide. L\'argent démo se réinitialise lorsque vous revenez en mode démo.',
  demoGuideWaitingForAction: 'Terminez l\'action mise en évidence pour continuer.',
  demoGuideDoThisFirst: 'Faites ceci d\'abord',
  ganamosPolyTrade: 'Ganamos PolyTrade',
  trending: 'Tendances',
  new: 'Nouveau',
  buyYes: 'Acheter Oui',
  breaking: 'Urgent',
  noBreakingMarketsRightNow: 'Aucun marché urgent pour le moment.',
  backToMarkets: 'Retour aux marchés',
  markets: 'Marchés',
  openFullMarket: 'Ouvrir le marché complet',
  tradeMarket: 'Trader le marché',
  previousMarket: 'Marché précédent',
  nextMarket: 'Marché suivant',
  breakingMarkets: 'Marchés urgents',
  showBreakingMarket: 'Afficher le marché urgent {{index}}',
  featuredMarkets: 'Marchés en vedette',
  topMovers: 'Plus fortes variations',
  viewAll: 'Tout voir',
  liveTrades: 'Trades en direct',
  live: 'En direct',
  featuredMarket: 'Marché en vedette',
  untitledMarket: 'Marché sans titre',
  traders: 'Traders',
  endsIn: 'Se termine dans',
  tradeNow: 'Trader maintenant',
  showFeaturedMarket: 'Afficher le marché en vedette {{index}}',
  openNewsHeadline: 'Ouvrir l\'actualité : {{headline}}',
  openNewsStatus: 'Ouvrir l\'actualité : {{statusText}}',
  news: 'Actualités',
  minimizeNews: 'Réduire les actualités',
  expandNews: 'Développer les actualités',
  closeNews: 'Fermer les actualités',
  liveWire: 'Fil en direct',
  categoryNews: 'Actualités {{category}}',
  categoryDesk: 'Desk {{category}}',
  topHeadlinesAndRelatedCoverage: 'Principaux titres et couverture associée pour cette catégorie de marché',
  topHeadlinesCount: '{{count}} principaux titres',
  moreRelevantNews: 'Plus d\'actualités pertinentes',
  noNewsStoriesForThisCategoryYet: 'Aucune actualité pour cette catégorie pour le moment.',
  pullingHeadlinesFromTheWire: 'Récupération des titres depuis le fil…',
  scanningWire: 'Analyse du fil…',
  categoryWaitingForStories: '{{category}} · en attente d\'articles',
  categoryStoriesCount: '{{category}} · {{count}} articles',
  searchMarkets: 'Rechercher des marchés...',
  searchPortfolioActivity: 'Rechercher l\'activité du portefeuille',
  refreshPortfolioActivity: 'Actualiser l\'activité du portefeuille',
  portfolioSections: 'Sections du portefeuille',
  noPositionsFound: 'Aucune position trouvée',
  yourOwnedPositionsWillAppearHere: 'Vos positions détenues apparaîtront ici.',
  noOrdersFound: 'Aucun ordre trouvé',
  marketOrdersWillAppearInThisSection: 'Les ordres au marché apparaîtront dans cette section.',
  limitOrdersWillAppearInThisSection: 'Les ordres limites apparaîtront dans cette section.',
  noActivityYet: 'Aucune activité pour le moment',
  completedTradesAndSettlementsWillBeListedHere: 'Les trades terminés et les règlements seront listés ici.',
  cancelThisOrder: 'Annuler cet ordre ?',
  cancelThisOrderDescription: 'Cela retirera votre ordre limite ouvert du carnet. Vous pouvez en placer un nouveau à tout moment.',
  keepOrder: 'Conserver l\'ordre',
  cancelOrder: 'Annuler l\'ordre',
  yourTradingDesk: 'Votre desk de trading',
  stateFilters: 'Filtres d\'état',
  tablePagination: 'Pagination du tableau',
  pagination: 'Pagination',
  previousPage: 'Page précédente',
  nextPage: 'Page suivante',
  noDataAvailable: 'Aucune donnée disponible',
  dataWillAppearHere: 'Les données apparaîtront ici',
  thumbnail: 'Vignette',
  actions: 'Actions',
  rowThumbnail: 'Vignette de ligne',
  yourPerformance: 'Votre performance',
  walletBalance: 'Solde du portefeuille',
  totalProfitIncludingTakerFee: 'Profit total frais taker inclus',
  totalProfit: 'Profit total',
  hideTakerFee: 'Masquer les frais taker',
  showTakerFee: 'Afficher les frais taker',
  profitOverTime: 'Profit dans le temps',
  noChartDataAvailable: 'Aucune donnée de graphique disponible',
  profitHistoryWillAppearAsTradesArePlaced: 'L\'historique des profits apparaîtra au fur et à mesure des trades.',
  profitChartTimeRange: 'Plage temporelle du graphique de profit',
  userActivity: 'Activité utilisateur',
  userActivityTitle: 'Activité utilisateur',
  userActivityTabs: 'Onglets d\'activité utilisateur',
  refreshUserActivity: 'Actualiser l\'activité utilisateur',
  addYourComment: 'Ajouter votre commentaire',
  shareYourThoughtsAboutThisMarket: 'Partagez votre avis sur ce marché...',
  anonymous: 'anonyme',
  hideReplies: 'Masquer les réponses',
  showReplies: 'Afficher les réponses',
  writeAReply: 'Écrire une réponse...',
  loadingEllipsis: 'Chargement...',
  recentMarketBuysAndSellsWillAppearHere: 'Les achats et ventes au marché récents apparaîtront ici.',
  topHolders: 'Principaux détenteurs',
  topPositions: 'Meilleures positions',
  noTopPositionsFound: 'Aucune position principale trouvée',
  topPositionsWillAppearHereWithHighestRealizedPnl: 'Les meilleures positions avec le PNL réalisé le plus élevé apparaîtront ici',
  yesHolders: 'Détenteurs Oui',
  noHolders: 'Détenteurs Non',
  noTopHoldersFoundForYesOutcome: 'Aucun principal détenteur trouvé pour le résultat Oui',
  topHoldersWillAppearHereForYesOutcome: 'Les principaux détenteurs du résultat Oui apparaîtront ici',
  noTopHoldersFoundForNoOutcome: 'Aucun principal détenteur trouvé pour le résultat Non',
  topHoldersWillAppearHereForNoOutcome: 'Les principaux détenteurs du résultat Non apparaîtront ici',
  optionDetailsTabs: 'Onglets des détails de l\'option',
  orderbookOutcome: 'Résultat du carnet',
  orderbook: 'Carnet d\'ordres',
  graph: 'Graphique',
  myPosition: 'Ma position',
  yesBook: 'Carnet Oui',
  noBook: 'Carnet Non',
  spread: 'Spread',
  you: 'Vous',
  noAsks: 'Aucun ask',
  noBids: 'Aucun bid',
  loadingPosition: 'Chargement de la position...',
  yourOrders: 'Vos ordres',
  marketOrdersForThisOptionWillAppearHere: 'Les ordres au marché pour cette option apparaîtront ici.',
  limitOrdersForThisOptionWillAppearHere: 'Les ordres limites pour cette option apparaîtront ici.',
  rulesAndMarketContext: 'Règles et contexte du marché',
  marketResolvesBasedOnListedCriteriaAndFinalOutcomeData: 'Le marché se résout selon les critères indiqués et les données finales du résultat.',
  matchingEngineSettlesOpenOrdersUsingMarketResolutionRules: 'Le moteur d\'appariement règle les ordres ouverts selon les règles de résolution du marché.',
  ambiguousOutcomesAreHandledByPlatformAdjudicationPolicy: 'Les résultats ambigus sont traités selon la politique d\'arbitrage de la plateforme.',
  defaultPredictionMarketRules: `
  Règles :
  - Ce marché se résout selon le résultat décrit dans la question. La résolution s'appuiera sur des sources publiques et fiables telles que des déclarations officielles, des fournisseurs de données vérifiés ou des organisations de presse réputées. 
  - Si le résultat devient clair avant la date de fin indiquée, le marché peut être résolu plus tôt. Si l'événement ne peut pas être déterminé ou si la question devient ambiguë, la plateforme peut résoudre le marché selon son meilleur jugement à partir des informations disponibles.
  - Toutes les résolutions sont définitives.`,
  pleaseLogInToFavouriteQuestions: 'Veuillez vous connecter pour ajouter des questions aux favoris.',
  removeFromFavourites: 'Retirer des favoris',
  addToFavourites: 'Ajouter aux favoris',
  unableToUpdateFavouriteQuestionPleaseTryAgain: 'Impossible de mettre à jour la question favorite. Veuillez réessayer.',
  marketOrderInProgress: 'Ordre au marché en cours',
  noActiveMarketOrder: 'Aucun ordre au marché actif',
  marketOrderRunning: 'Ordre au marché en cours d\'exécution',
  remainingAmount: 'Restant : ${{amount}}',
  remainingShares: 'Restant : {{shares}} parts',
  statusState: 'Statut : {{state}}',
  noMarketOrderRunning: 'Aucun ordre au marché en cours. Vous trouverez les ordres au marché passés dans l\'onglet Ordres de votre page Portefeuille.',
  deposit: 'Dépôt',
  withdraw: 'Retrait',
  closeWalletActivityModal: 'Fermer la fenêtre d\'activité du portefeuille',
  enterAmountToAction: 'Saisir le montant pour {{action}}',
  depositSuccessful: 'Dépôt réussi',
  depositFailedPleaseTryAgain: 'Échec du dépôt. Veuillez réessayer.',
  withdrawalSuccessful: 'Retrait réussi',
  withdrawFailedPleaseTryAgain: 'Échec du retrait. Veuillez réessayer.',
  mergeSuccessfulBalanceCredited: 'Fusion réussie. Solde crédité.',
  mergeSuccessfulCreditPending: 'Fusion réussie. Crédit en attente — le solde sera mis à jour sous peu.',
  orderPlacedSuccessfully: 'Ordre placé avec succès',
  placeOrderFailedPleaseTryAgain: 'Échec du placement de l\'ordre. Veuillez réessayer.',
  orderCancelledSuccessfully: 'Ordre annulé avec succès',
  cancelLimitOrderFailedPleaseTryAgain: 'Échec de l\'annulation de l\'ordre limite. Veuillez réessayer.',
  commentAdded: 'Commentaire ajouté',
  addCommentFailedPleaseTryAgain: 'Échec de l\'ajout du commentaire. Veuillez réessayer.',
  commentDeleted: 'Commentaire supprimé',
  deleteCommentFailedPleaseTryAgain: 'Échec de la suppression du commentaire. Veuillez réessayer.',
  failedToLoadNotifications: 'Échec du chargement des notifications',
  commentCannotBeEmpty: 'Le commentaire ne peut pas être vide.',
  commentNotFound: 'Commentaire introuvable.',
  demoMultiOutcomeMarket: 'Marché démo à résultats multiples',
  outcomeAlpha: 'Résultat Alpha',
  outcomeBeta: 'Résultat Bêta',
  outcomeGamma: 'Résultat Gamma',
  greatMarketToLearnLimitOrders: 'Bon marché pour apprendre les ordres limites — essayez de placer un bid sous le prix actuel.',
  theOrderbookUpdatesLiveOnceYouStartPlacingDemoOrders: 'Le carnet se met à jour en direct dès que vous placez des ordres démo.',
  demoOutcome: 'Résultat démo',
  demoMarketControls: 'Contrôles du marché démo',
  simulateCloseAndSettlementToSeeHowTheMarketBehaves: 'Simulez la fermeture et le règlement pour voir comment le marché se comporte.',
  closePanel: 'Fermer le panneau',
  closeMarket: 'Fermer le marché',
  tradingOpen: 'Trading ouvert',
  stopsTradingClearsTheOrderbookAndClosesOpenOrders: 'Arrête le trading, vide le carnet et ferme les ordres ouverts. Les montants prépayés restants sur les ordres bid retournent dans votre portefeuille. Les positions restent ouvertes jusqu\'au règlement.',
  marketClosed: 'Marché fermé',
  settleMarket: 'Régler le marché',
  ready: 'Prêt',
  awaitingClose: 'En attente de fermeture',
  pickTheWinningOutcomeDescription: 'Choisissez le résultat gagnant. Les parts gagnantes paient 1 $ chacune, les positions sont effacées et les options s\'affichent comme réglées avec le résultat final.',
  winningOutcome: 'Résultat gagnant',
  settlementOutcome: 'Résultat du règlement',
  closeManageMarketPanel: 'Fermer le panneau de gestion du marché',
  manageMarket: 'Gérer le marché',
  manageDemoMarket: 'Gérer le marché démo',
  noChartDataYet: 'Pas encore de données de graphique',
  priceHistoryWillAppearHereAsTradesHappen: 'L\'historique des prix apparaîtra ici au fil des trades.',
  chartTimeRange: 'Plage temporelle du graphique',
  allMarkets: 'Tous les marchés',
  backToCollateral: 'Retour à la garantie · {{marketTitle}}',
  demo: 'Démo',
  depositing: 'Dépôt en cours...',
  equalYesAndNoShares: 'Parts Oui et Non égales · {{marketTitle}}',
  estValue: 'Est. {{value}}',
  favouriteQuestions: 'Questions favorites',
  favourites: 'Favoris',
  feePerShareFormula: 'Frais par part (¢) = prix × (100 − prix) × {{coefficient}} / 10,000',
  limitBuy: 'Achat limite',
  limitSell: 'Vente limite',
  marketBuyOn: 'Achat au marché sur {{marketTitle}}',
  marketSellOn: 'Vente au marché sur {{marketTitle}}',
  marketResolutionPayoutReceived: 'Paiement de résolution du marché reçu. Nouveau solde : {{currency}} {{formattedBalance}}',
  marketsPagination: 'Pagination des marchés',
  noFavouriteQuestionsYet: 'Aucune question favorite pour le moment.',
  noTitle: 'Sans titre',
  optionNumber: 'Option {{number}}',
  postOnlyLimitBuy: 'Achat limite post-only',
  system: 'SYSTÈME',
  unknownOrderType: 'Type d\'ordre inconnu : {{orderType}}',
  withdrawing: 'Retrait en cours...',
  yourBalanceWasCredited: 'Votre solde a été crédité. Nouveau solde : {{currency}} {{formattedBalance}}',
  yourBalanceWasDebited: 'Votre solde a été débité. Nouveau solde : {{currency}} {{formattedBalance}}',
  thisMarket: 'ce marché',
  yourPositionText: 'votre position',
  amountYesAndNo: '{{amount}} Oui + {{amount}} Non',
  daysAgo: 'il y a {{days}} j',
  hoursAgo: 'il y a {{hours}} h',
  minutesAgo: 'il y a {{minutes}} min',
  outcomeSharesAtMarket: 'parts {{outcome}} au marché',
  sharesYesAndNo: '{{shares}} Oui + {{shares}} Non',
  sharesOutcomeAtPrice: '{{shares}} {{outcome}} @ {{price}}¢ · {{marketTitle}}',
  sharesOutcome: '{{shares}} parts {{outcome}}'
}


/**
 * NOTE:
 * =================================================================================================
 * Please go through this spreading objects first before adding new translation key. So that the
 * duplicate translations will not be created and help us to maintain the consitency of code.
 * If you didn't find any of translation as per your requirement in reserve or api success & error
 * msg translation object, Please add new translation with unique key name in otherTranslationKeys
 * Object. Unique key names help us to avoid overriding of translations.
 * =================================================================================================
 */
export default {
  ...en,
  ...reservedTranslationsWithUniqueKeyNames,
  ...apiSuccessMessagesTranslations,
  ...apiErrorMessagesTranslations,
  ...otherTranslationKeys,
  ...predictionMarketTranslations
}
